/* eslint-disable max-len */
import * as React from 'react';

const User = (props) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.3335 9.33333C21.3335 12.2789 18.9456 14.6667 16.0002 14.6667C13.0546 14.6667 10.6668 12.2789 10.6668 9.33333C10.6668 6.38781 13.0546 4 16.0002 4C18.9456 4 21.3335 6.38781 21.3335 9.33333ZM19.3335 9.33333C19.3335 11.1743 17.8411 12.6667 16.0002 12.6667C14.1592 12.6667 12.6668 11.1743 12.6668 9.33333C12.6668 7.49239 14.1592 6 16.0002 6C17.8411 6 19.3335 7.49239 19.3335 9.33333Z"
      fill="#5C5C5C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.6668 22.8888C26.6668 22.3111 26.4858 21.7432 26.1088 21.3053C23.6638 18.4651 20.0419 16.6667 16.0002 16.6667C11.9584 16.6667 8.33663 18.4651 5.89146 21.3053C5.51451 21.7432 5.3335 22.3111 5.3335 22.8888V25.3333C5.3335 26.8061 6.5274 28 8.00016 28H24.0002C25.473 28 26.6668 26.8061 26.6668 25.3333V22.8888ZM24.0002 26C24.3683 26 24.6668 25.7015 24.6668 25.3333V22.8888C24.6668 22.7179 24.6136 22.6339 24.5932 22.6101C22.5118 20.1924 19.4352 18.6667 16.0002 18.6667C12.5651 18.6667 9.48858 20.1924 7.40715 22.6101C7.38671 22.6339 7.3335 22.7179 7.3335 22.8888V25.3333C7.3335 25.7015 7.63198 26 8.00016 26H24.0002Z"
      fill="#5C5C5C"
    />
  </svg>
);
export default User;
